export default {
  default: () => import("/builds/ecom/shop-storefront/packages/frontend/src/layouts/default.vue"),
  reduced: () => import("/builds/ecom/shop-storefront/packages/frontend/src/layouts/reduced.vue")
}